module.exports = __webpack_public_path__ + "static/img/2.ed7863f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/huawei/2.png
// module id = YJow
// module chunks = 0